{{#each this}}
<li class="categories-list-item">
  <button class="categories-btn">{{category}}</button>
</li>
{{/each}}